import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import List from '@mui/material/List';

// Components
import AgendaHeader from './header';
import AgendaForm from './item';
import AgendaJornada from './journey/container';
import Modal from './modals/index';

// Util
import useOpen from '../../../../components/hooks/useOpen';
import ToolTip from '../../../../components/util/tooltip';
import { updateAgendaVisible } from '../../../../redux/actions/agendaActions';
import useAgendas from '../../../../swr/hooks/useAgendas';

const Agendas = () => {
    const dispatch = useDispatch();
    const loading = useSelector(state => state.agenda.loading);
    const { original: agendas, mutate } = useAgendas();
    const [select, setSelect] = useState(null);

    const modal = useOpen();

    const onSelect = (agenda) => setSelect(agenda);
    const onSelectBack = () => setSelect(null);
    const onVisible = (agenda) => {
        dispatch(updateAgendaVisible(agenda, mutate))
    };

    return select ? <AgendaJornada item={select} loading={loading} onSelectBack={onSelectBack} /> :
        (
            <div className="flex grow column">
                <AgendaHeader select={select} onCreate={modal.handleOpen} onSelectBack={onSelectBack} />
                <List component="ul">
                    {agendas.map((item) => <AgendaForm key={item.idAgenda} item={item} onSelect={onSelect} onVisible={onVisible} />)}
                </List>
                <ToolTip handleOpen={modal.handleOpen} title="Nueva agenda" color="primary" />
                <Modal item={select} open={modal.open} onClose={modal.handleClose} />
            </div>
        );
}

export default Agendas;